var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 0.5H4.1875V1.0625H9.8125V0.5H10.9375V1.0625H12.625H13.1875V1.625V12.875V13.4375H12.625H1.375H0.8125V12.875V1.625V1.0625H1.375H3.0625V0.5ZM1.9375 2.1875V3.3125H12.0625V2.1875H10.9375V2.75H9.8125V2.1875H4.1875V2.75H3.0625V2.1875H1.9375ZM1.9375 4.4375V12.3125H12.0625V4.4375H1.9375ZM5.3125 5.5625H6.4375V6.6875H5.3125V5.5625ZM7.5625 5.5625H8.6875V6.6875H7.5625V5.5625ZM9.8125 5.5625H10.9375V6.6875H9.8125V5.5625ZM3.0625 7.8125H4.1875V8.9375H3.0625V7.8125ZM5.3125 7.8125H6.4375V8.9375H5.3125V7.8125ZM7.5625 7.8125H8.6875V8.9375H7.5625V7.8125ZM9.8125 7.8125H10.9375V8.9375H9.8125V7.8125ZM3.0625 10.0625H4.1875V11.1875H3.0625V10.0625ZM5.3125 10.0625H6.4375V11.1875H5.3125V10.0625ZM7.5625 10.0625H8.6875V11.1875H7.5625V10.0625Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSmallIcon);
export default __webpack_public_path__ + "static/media/calendarSmallIcon.f804b7f312e1a9e874f2002f188bd517.svg";
export { ForwardRef as ReactComponent };